export default {
  apiUrl() {
    return process.env.VUE_APP_BASE_URL;
  }
};
